import homepage from '../objects/homepage/index';

// run all related funcs here
homepage();
